import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import {
  fetchTranslationsFor,
  translatePage,
} from "/WebInterface/new-ui/modules/localizations/localizations.js";

window.translations = {};
window.locale = "";

const setLocale = async ({ newLocale }) => {
  if (newLocale === locale) return;

  const localeCode = utils.doWeSupportThisLanguage(newLocale)
    ? newLocale
    : "en";

  const newTranslations = await fetchTranslationsFor(localeCode);
  document.documentElement.lang = localeCode;

  locale = localeCode;
  translations = newTranslations;
  translatePage();
};

export default setLocale;
